module.exports = __webpack_public_path__ + "static/media/FidemLogo.a1cf61b9.png";